import { z } from 'zod';

import { translate } from '@front/i18n';

const t = translate('inputs');

export const salutationSchema = z
  .string()
  .optional()
  .superRefine((value, ctx) => {
    if (!value || (value !== 'M.' && value !== 'Mme')) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: t('inputs.salutation.errors.required'),
      });
    }
  });
